import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserHover } from "../../Components";
import { useUserTypeList } from "../../Constant/apiHooks";
import { Validator } from "../../Utils/validator";
import { newAuthService } from "../../Service/Axios";
import { CREATE_INVITE_URL, GET_INVITE_LIST_URL } from "../../Constant/api";
import { toast } from "react-toastify";
import { getFirstLetterOfName } from "../../Utils";
import { OverlayTrigger, Popover } from "react-bootstrap";

export default function InviteMember() {
  const { t } = useTranslation();

  const [inviteList, setInviteList] = useState([]);

  const [formData, setFormData] = useState({
    userType: "",
    email: "",
  });
  const [errMsg, setErrMsg] = useState({
    userType: "",
    email: "",
  });

  const { email, userType } = formData;

  const { userTypeList } = useUserTypeList();

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

    if (e.target.name === "email") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.blank"),
        }));
      } else if (e.target.value && !Validator.email(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.inValid"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          email: "",
        }));
      }
    }

    if (e.target.name === "userType") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          userType: t("common.messages.error.common.userType.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          userType: "",
        }));
      }
    }
  };

  //  Listing
  const getInviteList = async () => {
    const payload = {};
    const response = await newAuthService(GET_INVITE_LIST_URL, "POST", payload);
    if (response.status) {
      setInviteList(response.data);
    } else {
      setInviteList([]);
    }
  };

  useEffect(() => {
    getInviteList();
  }, []);

  // Validation
  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(userType) && Validator.email(email)) {
        resolve(true);
      } else {
        if (!Validator.text(userType)) {
          setErrMsg((prev) => ({
            ...prev,
            userType: t("common.messages.error.common.userType.blank"),
          }));
        }

        if (!Validator.text(email)) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.blank"),
          }));
        } else if (email && !Validator.email(email)) {
          setErrMsg((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.inValid"),
          }));
        }

        resolve(false);
      }
    });
  };

  const handleCreateInvite = async (e) => {
    e.preventDefault();
    const validationStatus = await getValidation();
    if (validationStatus) {
      const payload = {
        email,
        type: userType,
      };
      const response = await newAuthService(CREATE_INVITE_URL, "POST", payload);
      if (response.status) {
        getInviteList();
        toast.success(t("common.messages.notification.success.imviteSend"));
      } else {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    }
  };

  return (
    <main className="main">
      <div className="p-4 rounded-3 bg-white">
        <div className="invite-search-box my-3">
          <form onSubmit={handleCreateInvite}>
            <div className="input-group gap-2">
              <input
                type="text"
                className="form-control form-control-lg rounded-2 border-2"
                placeholder={t("common.placeHolder.email")}
                name="email"
                value={email}
                onChange={handleChange}
              />

              {errMsg.email && <p className="error">{errMsg.email}</p>}

              <select
                className="form-select form-select-lg rounded-2 border-2"
                aria-label="Default select example"
                name="userType"
                value={userType}
                onChange={handleChange}
              >
                <option value="">{t("common.placeHolder.userType")}</option>
                {userTypeList?.length > 0 &&
                  userTypeList.map((type) => (
                    <option value={type.name} key={type.id}>
                      {type.name}
                    </option>
                  ))}
              </select>

              {errMsg.userType && <p className="error">{errMsg.userType}</p>}

              <button
                className="btn btn-secondary px-4 text-white rounded-2"
                type="submit"
                id="button-addon2"
              >
                Invite
              </button>
            </div>
          </form>
        </div>

        <h4 className="h6 mb-4 text-grey-800">Recent invite</h4>
        <form className="from-box from-box-lg">
          <ul className="m-0 p-0">
            {inviteList?.length > 0 &&
              inviteList.map((invite, index) => (
                <li
                  className="row gy-2 align-items-center"
                  key={index.toString()}
                >
                  <div className="col-md-3 col-sm-6 col-12">
                    <div className="position-relative cursor-pointer">
                    <OverlayTrigger
                        placement="right"
                        overlay={
                          <Popover className="max-w-unset">
                            <UserHover user={invite} />
                          </Popover>
                        }
                      >
                        <div className="d-flex align-items-center">
                        <div className="w-12 h-12 flex-auto me-2 d-flex justify-content-center align-items-center text-white rounded-circle bg-purple-600">
                          {invite.photoURL ? (
                            <div className="img-box w-100 h-100">
                              <img
                                src={invite.photoURL}
                                alt={`${invite.firstName}${invite.lastName}`}
                                className="w-100 h-100 object-fit-cover"
                              />
                            </div>
                          ) : (
                            getFirstLetterOfName(invite)
                          )}
                        </div>
                        <a
                          href={invite.email}
                          className="text-grey-800 text-decoration-none text-sm font-medium"
                        >
                          {invite.email}
                        </a>
                      </div>
                      </OverlayTrigger>
                     
                      {/* <UserHover user={invite} /> */}
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6 col-12">
                    <div className="">
                      <label htmlFor="firstName2" className="form-label">
                        {invite.firstName || ""}
                      </label>
                      {/* <input
                        type="text"
                        className="form-control form-control-lg"
                        id="firstName2"
                        value={invite.firstName || ""}
                        readOnly
                      />{" "} */}
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-6 col-12">
                    <div className="">
                      <label htmlFor="lastName2" className="form-label">
                        {invite.lastName || ""}
                      </label>
                      {/* <input
                        type="text"
                        className="form-control form-control-lg"
                        id="lastName2"
                        value={invite.lastName || ""}
                        readOnly
                      />{" "} */}
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-6 col-12">
                    <div className="">
                      <label htmlFor="role" className="form-label">
                        {invite.type}
                      </label>
                      {/* <select
                        className="form-select form-select-lg"
                        aria-label="Default select example"
                        // name="userType"
                        value={invite.type}
                        // onChange={handleChange}
                        readOnly
                      >
                        <option value="">
                          {t("common.placeHolder.userType")}
                        </option>
                        {userTypeList?.length > 0 &&
                          userTypeList.map((type) => (
                            <option value={type.id} key={type.id}>
                              {type.name}
                            </option>
                          ))}
                      </select> */}
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-6 col-12">
                    <div className="text-center">
                      <span className="px-3 py-1 text-xs font-semibold text-green-600 rounded-2 border border-green-300 bg-green-100">
                        {invite.status}
                      </span>
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </form>
      </div>
    </main>
  );
}
